var map = {
	"./locale-provider/en_US.js": "./components/locale-provider/en_US.js",
	"./locale-provider/zh_CN.js": "./components/locale-provider/zh_CN.js",
	"./locale-provider/zh_TW.js": "./components/locale-provider/zh_TW.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./components sync recursive ^\\.\\/locale-provider\\/(?!__tests__).+_.+\\.js$";